import { render, staticRenderFns } from "./PatientEligibility.vue?vue&type=template&id=5f0d8e48"
import script from "./PatientEligibility.vue?vue&type=script&lang=js"
export * from "./PatientEligibility.vue?vue&type=script&lang=js"
import style0 from "./PatientEligibility.vue?vue&type=style&index=0&id=5f0d8e48&prod&scopped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports